import { useEffect, useState } from "react";
import { useGetIdentificationType } from "../callApis/getIdentificationType";
import { useDispatch } from "react-redux";
import { identificationTypeClearData } from "../../../store/identificationType/actions";
export var useIdentificationTypeData = function () {
    var dispatch = useDispatch();
    var _a = useState([]), identificationTypesList = _a[0], setIdentificationTypesList = _a[1];
    var _b = useGetIdentificationType(true), responseIdentificationType = _b.responseIdentificationType, errorIdentificationType = _b.errorIdentificationType, loadingIdentificationType = _b.loadingIdentificationType;
    useEffect(function () {
        var _a;
        if (responseIdentificationType &&
            ((_a = responseIdentificationType === null || responseIdentificationType === void 0 ? void 0 : responseIdentificationType.data) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            var newList = responseIdentificationType.data.map(function (item) { return ({
                id: item.id,
                name: item.description,
                value: item.id,
            }); });
            setIdentificationTypesList(newList);
            dispatch(identificationTypeClearData());
        }
    }, [responseIdentificationType]);
    return {
        errorIdentificationType: errorIdentificationType,
        loadingIdentificationType: loadingIdentificationType,
        identificationTypesList: identificationTypesList,
    };
};
